<template>
    <div class="right_box_main">
        <div class="listBox-item">
            <!-- <div class="mianbao">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/griddingindex' }">网格工作</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/twoNetworkConvergence' }">两网融合</el-breadcrumb-item>
                    <el-breadcrumb-item>考勤列表</el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->
            <el-card class="publicCard">
                <div class="fisthang">
                    <el-form :inline="true" class="demo-form-inline" size="mini">
                        <!-- <el-form-item label="组织机构" >
                            <orgListSelect orgType="1" v-model="orgid" :on-success="onSuccess" />
                        </el-form-item>-->
                        <el-form-item label="日期">
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="getData">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="reset()">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="listBox-item">
                    <!-- 表格盒子 -->
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column align="center" prop="orgName" label="组织机构" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="attendanceNum" label="应出勤(人*次)"></el-table-column>
                            <el-table-column
                                align="center"
                                prop="normalAttendanceNum"
                                label="正常考勤(人*次)"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="noAttendanceNum"
                                label="缺勤(人*次)"
                            >
                                <!-- <template
                                    slot-scope="scope"
                                >{{noAttendanceNum}}</template> -->
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="abnormalAttendanceNum"
                                label="异常考勤(人*次)"
                            ></el-table-column>
                            <el-table-column align="center" prop="AttendanceRate" label="考勤率">
                                <!-- <template
                                    slot-scope="scope"
                                >{{(scope.row.normalAttendanceNum/scope.row.attendanceNum).toFixed(2)}}%</template> -->
                            </el-table-column>
                            <el-table-column align="center" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="查看"
                                        placement="top-start"
                                    >
                                        <button
                                            class="iconfont icon-chakan tabBtn"
                                            @click="getwgList(scope.row)"
                                        ></button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
            <el-dialog :title="list.name+'考勤列表'" :visible.sync="list.visible" width="1200px">
                <attendanceListwg :communityId="list.communityId" v-if="list.off"></attendanceListwg>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import orgListSelect from "@/component/orgListSelect/index.vue";
import attendanceListwg from "./attendanceListwg.vue";
export default {
    components: { orgListSelect, attendanceListwg },
    data() {
        return {
            orgid: [],
            tableData: [],
            time: "",
            list: {
                visible: false,
                off: true,
                communityId: "",
                name: ""
            }
        };
    },
    methods: {
        onSuccess(info) {
            // this.orgid = info.value;
            // this.getUser(info.value);
        },
        //获取数据
        getData() {
            console.log(this.time);
            this.$post(
                "admin/attendanceRecord/info/attendanceRecordStatisticsByCommunity",
                {
                    startTime: this.time[0] ? this.time[0] : "",
                    endTime: this.time[1] ? this.time[1] : ""
                }
            ).then(res => {
                res.content.map((item,index)=>{
                    if(item.orgName == null){
                        res.content.splice(index,1)
                        return
                    }
                    let num = (res.content[0].normalAttendanceNum / res.content[0].attendanceNum * 100).toFixed(1) + '%'
                    this.$set(item,'AttendanceRate',num)
                })
                this.tableData = res.content;
            });
        },
        //重置日期
        reset:function(){
            this.time = ""
            this.getData()
        },
        getwgList(row) {
            this.list.visible = true;
            this.list.communityId = row.communityId;
            this.list.name = row.orgName;
            this.list.off = false;
            this.$nextTick(_ => {
                this.list.off = true;
            });
        }
    },
    mounted() {
        this.getData();
    },
    created() {}
};
</script>

<style lang="less" scoped>
</style>
